export default function formatShortName(fullName = "") {
  if (!fullName || typeof fullName !== "string") {
    return "";
  }

  const parts = fullName.trim().split(/\s+/).filter(Boolean);

  if (parts.length <= 2) {
    return parts.join(" ");
  }

  return `${parts[0]} ${parts[1]}`;
}
